export default "__VITE_ASSET__C17Vgvfd__"